// LIBRERIE/IMPORTS
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagnifyingGlassPlus, faHouseCircleCheck, faChartPie  } from "@fortawesome/free-solid-svg-icons";

//IMG
import vadaImg from "../../../public/assets/images/inHome/vada.jpg";

const ServicesSection: React.FC = () => {
  const { t } = useTranslation();

  const servicesIcon = [
    {
      icon:  <FontAwesomeIcon icon={faHouseCircleCheck} />,
      title: t('homePage.servicesSection.serviceTitle1'),
      description: t('homePage.servicesSection.description1')
    },
    {
      icon: <FontAwesomeIcon icon={faChartPie} />,
      title: t('homePage.servicesSection.serviceTitle2'),
      description: t('homePage.servicesSection.description2')
    },
    {
      icon: <FontAwesomeIcon icon={faMagnifyingGlassPlus} />,
      title: t('homePage.servicesSection.serviceTitle3'),
      description: t('homePage.servicesSection.description3')
    }
  ];

  /* transizione per apparizione icone + testi */
  const liServies = useRef<(HTMLLIElement|null)[]>([]);
  const setRef = (element: HTMLLIElement|null, index: number) => {
      liServies.current[index] = element;
  }
  const [visible, setVisible] = useState<boolean[]>([false,false,false])

  useEffect(() => {
    const handleScroll = () => {
      liServies.current.forEach((liElement, index) => {
          const liPosition = liElement?.getBoundingClientRect();
          const positionInDOM = liPosition? liPosition.bottom + window.scrollY : 0
          const clientViewHeight = window.scrollY + window.innerHeight;
          if( positionInDOM < clientViewHeight){
              setVisible((prevVisible) => {
                  const newVisible = [...prevVisible]; 
                  newVisible[index] = true; 
                  return newVisible;
              });
          }
      })
    }

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    }
  }, [])
    
  return (
    <section id="service-box" className="space-pt" >
      <div className="container-fluid">
        <div className="d-lg-flex align-items-center mb-4 mb-lg-5">
          <h2 className="m-0" dangerouslySetInnerHTML={{ __html: t('homePage.servicesSection.title') as string }} />
          <p className="m-0" dangerouslySetInnerHTML={{ __html: t('homePage.servicesSection.para1') as string }} />
        </div>
        <div className="row justify-content-center align-items-center">
          <div className="col-12 col-lg-6 col-xl-5 my-5">
            <ul className="list-unstyled mb-4 mb-lg-0">
              { servicesIcon.map((service, index) => (
                <li key={index} className={`d-md-flex align-items-center text-center mb-3 ${visible[index]? 'visible' : ''}`} ref={(element) => setRef(element, index)}>
                  {service.icon}
                  <div className="text-md-left">
                    <h4>{service.title}</h4>
                    <p>{service.description}</p>
                  </div>
                </li>
              ))}
            </ul>
          </div>
          <div className="col-12 col-sm-10 col-lg-6 col-xl-7">
            <img src={vadaImg} className="img-fluid" alt={`${t('homePage.servicesSection.imgAlt1')}`} />
            <div className="red-box d-flex justify-content-around">
              <div className="d-flex align-items-center">
                <span>30</span>
                <p className="m-0 ml-3" dangerouslySetInnerHTML={{ __html: t('homePage.servicesSection.rebBoxText1') as string }} />
              </div>
              <div className="d-none d-sm-flex align-items-center">
                <span>+3000</span>
                <p className="m-0 ml-3" dangerouslySetInnerHTML={{ __html: t('homePage.servicesSection.rebBoxText2') as string }} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;